// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import Firebase Storage

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCLf3C0ZD4z9Anu1QK2NlAnjI-5r2NRats",
    authDomain: "sofia-832b0.firebaseapp.com",
    projectId: "sofia-832b0",
    storageBucket: "sofia-832b0.firebasestorage.app",
    messagingSenderId: "843080509209",
    appId: "1:843080509209:web:cb73a4686628a774034788",
    measurementId: "G-JLG8TEKTQT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Storage
const storage = getStorage(app);

export { db, storage }; // Export both Firestore and Storage